import React from 'react';

import { MessageBlock } from '@getro/rombo';
import { useTierGating } from 'hooks/useTierGating';
import { MainLayoutHeader } from '../../components/atoms/mainLayoutHeader';
import MainLayout from '../../components/layout/Main';
import { ConnectHome } from './connectHome';

const Home = () => {
  const { hasAccessToContacts } = useTierGating();

  return (
    <MainLayout>
      <MainLayoutHeader title="Home" />
      {hasAccessToContacts ? (
        <ConnectHome />
      ) : (
        <MessageBlock
          type="warning"
          title="No access"
          content="Sorry, you don't have the necessary permissions to access this page."
        />
      )}
    </MainLayout>
  );
};

export default Home;
